import { Color } from 'shared/utils/colors';

export const floatingToolbarSx = (visible: boolean) => ({
  position: 'fixed',
  bottom: 24,
  left: '50%',
  zIndex: 1300,
  display: 'flex',
  alignItems: 'center',
  gap: 1.5,
  px: 2.5,
  py: 1.5,
  borderRadius: '28px',
  backgroundColor: Color.black,
  boxShadow: '0 8px 32px rgba(0,0,0,0.35)',
  transform: visible ? 'translateX(-50%) translateY(0)' : 'translateX(-50%) translateY(24px)',
  opacity: visible ? 1 : 0,
  visibility: visible ? 'visible' : 'hidden',
  pointerEvents: visible ? 'auto' : 'none',
  transition: 'transform 250ms ease, opacity 250ms ease, visibility 250ms ease',
} as const);

export const floatingToolbarCountSx = {
  color: Color.white,
  whiteSpace: 'nowrap',
  pl: 0,  
  mr: 0.5,
  fontWeight: 500,
} as const;

const floatingToolbarIconBaseSx = {
  color: Color.white,
  width: 28,
  height: 28,
  padding: '5px',
  borderRadius: '50%',
  transition: 'background-color 150ms ease',
} as const;

export const floatingToolbarIconSx = {
  ...floatingToolbarIconBaseSx,
  '&:hover': {
    backgroundColor: Color.primaryOrange,
    color: Color.black,
  },
} as const;

export const floatingToolbarCloseIconSx = {
  ...floatingToolbarIconBaseSx,
  '&:hover': {
    backgroundColor: 'rgba(255,255,255,0.2)',
  },
} as const;
